module.exports = new __parcel__URL__("lune-nuage-2-pluie-2.4420f248.svg").toString();